import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { CandidateServicePath, CANDIDACIES } from "utils/constants";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";
import CandidatesPage from "./Page";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <AssignmentIndIcon />,
  name: CandidateServicePath + CANDIDACIES,
  title: "Кандидатури",
  custom: <CandidatesPage />,
  permission: [permissions.canPreviewCandidacies, permissions.canPreviewPreparatoryYearCandidates],
};

export { candidateResources } from "./candidateResources";
